import {getMethod, putMethod} from '@/api'

export const getForHotel = async hotelId => await getMethod(`/api/channelManagersConfig/hotel/${hotelId}`)

export const updateForHotel = async (hotelId, configs) => await putMethod(`/api/channelManagersConfig/hotel/${hotelId}`, configs)

export const getForRoom = async roomId => await getMethod(`/api/channelManagersConfig/hotelRoom/${roomId}`)

export const updateForRoom = async (roomId, configs) => await putMethod(`/api/channelManagersConfig/hotelRoom/${roomId}`, configs)
